import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { useI18n } from "@/locales/client";
import { useTRPC } from "@/trpc/client";

const TIMEFRAME_LABELS: Record<string, string> = {
  "2_weeks": "2 weeks",
  "1_month": "1 month",
  "2_months": "2 months",
  next_semester: "4 months",
  not_sure: "1 month",
};

export const usePauseSubscription = () => {
  const trpc = useTRPC();
  const queryClient = useQueryClient();
  const t = useI18n();

  return useMutation(
    trpc.stripe.pauseSubscription.mutationOptions({
      onSuccess: (_data, variables) => {
        queryClient.invalidateQueries({
          queryKey: trpc.users.getUserPlan.queryKey(),
        });
        queryClient.invalidateQueries({
          queryKey: trpc.users.getPlanLimit.queryKey(),
        });
        const duration =
          TIMEFRAME_LABELS[variables?.timeframe ?? ""] ?? "1 month";
        toast.success(t("cancellation.toast.pauseSuccess"), {
          // @ts-expect-error
          description: t("cancellation.toast.pauseSuccessDescription", {
            duration,
          }),
        });
      },
      onError: (error) => {
        console.error("Failed to pause subscription", error);
        toast.error(t("cancellation.toast.pauseError"), {
          description: t("cancellation.toast.pauseErrorDescription"),
        });
      },
    }),
  );
};
